import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { LoginValidator } from "../login/loginValidator";
import { Prevbutton, EyeIcon } from "../../../assets/images";
import { Input, Button, PageHeader, Checkbox } from "../../../components/";
import { EndPoints } from "../../../api";
import axios from "axios";
import {
  loginButtonWrapper,
  loginEmailWrap,
  loginPasswordWrap,
  prevbuttonWrapper,
  forgotText,
  forgotWrapper,
  loginSupportWrapper,
  loginSupportText,
  loginSupportLink,
  loginForm,
} from "./login.module.css";
import { localStoreName } from "../../../utils/constants";
import { toast } from "react-toastify";
import { AlertContext } from "../../../context/context";

const Login = () => {
  const history = useHistory();

  const [showPassword, setShowPassword] = useState(false);
  const { setAlertState } = useContext(AlertContext);

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = () => {
    setLoading(true);
    axios
      .post(EndPoints.login, { ...values, portal: "application" })
      .then((res) => {
        if (res?.data?.success) {
          setLoading(false);
          localStorage.setItem(localStoreName, JSON.stringify(res?.data?.data));
          history.push("/dashboard");
        }
      })
      .catch((err) => {
        setError(true);
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  const { values, errors, handleChange, handleSubmit, touched } = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema: LoginValidator,
    onSubmit: handleOnSubmit,
  });

  return (
    <form className={loginForm} onSubmit={handleSubmit}>
      <Link to="/">
        <div className={prevbuttonWrapper}>
          <img src={Prevbutton} alt="Previous Iocn" />
        </div>
      </Link>

      <PageHeader
        head="Start your journey"
        text="Gain access to your Profile, Resources and Test."
      />
      <div className={loginEmailWrap}>
        <Input
          type="text"
          placeholder="Enter email address"
          label="Email address"
          name="email"
          value={values.email}
          onChange={handleChange}
          errorText={touched.email ? errors.email : ""}
        />
      </div>
      <div className={loginPasswordWrap}>
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="Enter password"
          label="Password"
          name="password"
          icon={
            <EyeIcon
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            />
          }
          value={values.password}
          onChange={handleChange}
          errorText={touched.password ? errors.password : ""}
        />
      </div>
      <div className={forgotWrapper}>
        <div>
          <Checkbox type="checkbox" />
          <p className={forgotText}>Remember me</p>
        </div>
        <p
          className={forgotText}
          onClick={() => history.push("/forgot-password")}
        >
          Forgot password?
        </p>
      </div>
      <div className={loginButtonWrapper}>
        <Button
          buttonName={loading ? "" : "Start journey"}
          main="fill"
          type="submit"
          loading={loading}
        />
        <div className={loginSupportWrapper}>
          <p className={loginSupportText}>Experiencing Issues?</p>
          <span
            className={loginSupportLink}
            onClick={() => history.push("/contact")}
          >
            Contact support
          </span>
        </div>
      </div>
    </form>
  );
};
export { Login };
